import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { RouteHttpVerb } from ".";
/**
 * Get the result of the `Response`. It also handles multiline responses, e. g.
 * a PHP `Notice:` message is output through a conflicting plugin:
 *
 * If you are using a verb like `DELETE` or `PUT` the response may be empty and this
 * function will return `undefined`.
 *
 * @see https://developer.mozilla.org/de/docs/Web/HTTP/Methods/DELETE
 */

function parseResult(_x, _x2, _x3) {
  return _parseResult.apply(this, arguments);
}

function _parseResult() {
  _parseResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, result, method) {
    var cloneForFallback, body, lastError, _iterator, _step, line;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cloneForFallback = result.clone();
            _context.prev = 1;
            _context.next = 4;
            return result.json();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            _context.next = 11;
            return cloneForFallback.text();

          case 11:
            body = _context.sent;

            if (!(body === "" && [RouteHttpVerb.DELETE, RouteHttpVerb.PUT].indexOf(method) > -1)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", undefined);

          case 14:
            console.warn("The response of ".concat(url, " contains unexpected JSON, try to resolve the JSON line by line..."), {
              body: body
            });
            _iterator = _createForOfIteratorHelper(body.split("\n"));
            _context.prev = 16;

            _iterator.s();

          case 18:
            if ((_step = _iterator.n()).done) {
              _context.next = 30;
              break;
            }

            line = _step.value;

            if (!(line.startsWith("[") || line.startsWith("{"))) {
              _context.next = 28;
              break;
            }

            _context.prev = 21;
            return _context.abrupt("return", JSON.parse(line));

          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](21);
            lastError = _context.t1;

          case 28:
            _context.next = 18;
            break;

          case 30:
            _context.next = 35;
            break;

          case 32:
            _context.prev = 32;
            _context.t2 = _context["catch"](16);

            _iterator.e(_context.t2);

          case 35:
            _context.prev = 35;

            _iterator.f();

            return _context.finish(35);

          case 38:
            throw lastError;

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7], [16, 32, 35, 38], [21, 25]]);
  }));
  return _parseResult.apply(this, arguments);
}

export { parseResult };